import { render, staticRenderFns } from "./FilterLanguagesModal.vue?vue&type=template&id=08543872&scoped=true"
import script from "./FilterLanguagesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterLanguagesModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterLanguagesModal.vue?vue&type=style&index=0&id=08543872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08543872",
  null
  
)

export default component.exports